import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=615a02b4&"
import script from "./PackagesList.vue?vue&type=script&lang=js&"
export * from "./PackagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports